import {
  customizing_features,
  enterprise_features,
  support_features,
} from 'data/Pricing/EntrpriseFeatures'
import React from 'react'

const CustomizingFeatures = () => {
  return (
    <div className=" w-full ">
      <div className=" w-full flex flex-col  gap-3 md:gap-4  mb-12 md:mb-[72px]">
        <p className="  text-base  font-semibold text-primary">Features</p>
        <h2 className="h2">Customize Everything</h2>
        <p className=" text-lightGray text-[18px] font-medium  leading-[27px] max-w-screen-md mr-0">
          Engage your customers, enhance their experience, and win them for life!
        </p>
      </div>

      <div className=" grid  grid-cols-1 md:grid-cols-3 gap-x-8  gap-y-10 md:gap-y-12">
        {customizing_features.map((feature) => {
          return (
            <div className=" flex items-start justify-start   flex-col">
              <div className=" mb-6 w-full h-fit bg-#f1f3f7  ">
                <img
                  src={feature?.image}
                  loading="lazy"
                  sizes="(max-width: 479px) 93vw, (max-width: 767px) 96vw, (max-width: 991px) 29vw, (max-width: 1439px) 30vw, 405.3359375px"
                  alt="Mockup"
                  class="layout73_image"
                />
              </div>
              <h4 className=" h4 !text-[20px]  mb-2">{feature.title} </h4>
              <p className="text-lightGray text-base font-medium  leading-[24px]">
                {feature.description}
              </p>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CustomizingFeatures
